import React from 'react';

import { JomsomFAQ, CommonFAQ } from '../SearchAndResults/StaticSections';
import { subTitle, sectors, appendStatic } from './common';

const pageTitle = 'Pokhara to Jomsom Flight at USD 117';

const jomsom = {
  pageTitle,
  subTitle,
  CreditMessage: () => (
    <p className="ext-word">
      * Includes USD 4 HoneyGuide Credits with each ticket.
    </p>
  ),
  seo: {
    title: appendStatic(pageTitle),
    description:
      'Get upto USD 4 Credits with each ticket. 24x7 hours support from people who know the mountains. 72 hours Free Cancellation. Online Flight Booking between Pokhara and Jomsom',
    image:
      'https://s3.amazonaws.com/honeyguide/assets/book-lukla-flights-new.jpg',
  },
  from: 'PKR',
  to: 'JMO',
  sectors,
  valueProps: [
    'Price Match Guarantee',
    'Free 24 hours cancellation',
    '24x7 support from HoneyGuide',
  ],
  // About: () => <AboutJomson />,
  Faq: () => {
    return (
      <React.Fragment>
        <JomsomFAQ />
        <CommonFAQ />
      </React.Fragment>
    );
  },
  pricesToCompare: [
    { url: 'https://honeyguide.s3.amazonaws.com/assets/yeti-air2.png', price: 'USD 116.95', subText: '*Without Transport.' },
    { url: 'https://honeyguide.s3.amazonaws.com/assets/sasto-tickets.png', price: 'USD 118', subText: '*Without Transport.' },
    { url: 'https://honeyguide.s3.amazonaws.com/assets/kathmandu-lukla-flight.png', price: 'USD 125', subText: '*Without Transport.' },
  ],
};

export default jomsom;



// WEBPACK FOOTER //
// ./src/screens/Flights/static-db/jomsom.js